import getConfig from 'next/config';

/**
 * @param {string} language
 * @param {string | undefined} [query]
 * @returns {Promise<TermsApiResponse>}
 */
const get = (language, query = '') => {
  const { publicRuntimeConfig } = getConfig();

  /**
   * @type {TermsApiHeaders}
   */
  const headers = {
    Accept: 'application/json',
    'Accept-Language': language,
  };
  return fetch(`${publicRuntimeConfig.termsApiBaseUrl}/${query}`, {
    headers,
  }).then((res) => {
    return res.json();
  });
};

export default {
  get,
};
